import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { dispatch } from 'store'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { userSelectors } from 'store/features/user/selectors'
import { creditsSelectors } from 'store/features/credits/selectors'
import { useOpenUpgradePopup } from 'hooks/useOpenUpgradePopup'
import { REF_LINKS } from 'consts/refLinks'
import { usePendingRetryRef } from 'context/PowerModeRetryContext'
import { useGenerationCredits } from 'hooks/useGenerateVideo'
import PowerModePopup from 'containers/SubSidebar/AIVideoContent/GenerateTab/Footer/PowerModePopup'

export const PowerModeRequiredPopup = () => {
  const pendingRetryRef = usePendingRetryRef()

  const isOpen = useSelector(aiVideoSelectors.isPowerModeRequiredPopupOpen)
  const isFreeUser = useSelector(userSelectors.isFreeUser)
  const { generationCreditsIfPowerOn: powerOnCredits } = useGenerationCredits()
  const userCredits = useSelector(creditsSelectors.userCredits) || 0
  const hasInsufficientCredits = userCredits < powerOnCredits
  const openUpgradePopup = useOpenUpgradePopup()

  const onClose = useCallback(() => {
    pendingRetryRef.current = null
    dispatch(aiVideoThunks.setIsPowerModeRequiredPopupOpen(false))
  }, [pendingRetryRef])

  const onConfirm = useCallback(() => {
    dispatch(aiVideoThunks.setIsPowerModeRequiredPopupOpen(false))
    if (isFreeUser || hasInsufficientCredits) {
      pendingRetryRef.current = null
      openUpgradePopup({ ref: REF_LINKS.V_EDITOR_AI_VIDEO_GENERATE })
      return
    }
    dispatch(aiVideoThunks.setIsFastTrack(true))
    const retry = pendingRetryRef.current
    pendingRetryRef.current = null
    retry?.()
  }, [isFreeUser, hasInsufficientCredits, openUpgradePopup, pendingRetryRef])

  return (
    <PowerModePopup
      isOpen={isOpen}
      isFreeUser={isFreeUser}
      hasInsufficientCredits={hasInsufficientCredits}
      onClose={onClose}
      onConfirm={onConfirm}
      credits={powerOnCredits}
    />
  )
}
